import { get as _get } from 'lodash';

import types from '../actionTypes';

const initialState = {
    info: {
        detail: true,
    },
    infoCategories: {
        list: true,
        detail: true,
    },
};

const reducer = (state = initialState, action) => {
    if (_get(action, 'meta.silent')) {
        return state;
    }
    switch (action.type) {
        case types.INFO_CATEGORIES_REQUEST: {
            return {
                ...state,
                infoCategories: {
                    ...state.infoCategories,
                    list: true,
                },
            };
        }
        case types.INFO_CATEGORIES_REQUEST_COMPLETED: {
            return {
                ...state,
                infoCategories: {
                    ...state.infoCategories,
                    list: false,
                },
            };
        }
        case types.INFO_CATEGORY_DETAIL_REQUEST: {
            return {
                ...state,
                infoCategories: {
                    ...state.infoCategories,
                    detail: true,
                },
            };
        }
        case types.INFO_CATEGORY_DETAIL_REQUEST_COMPLETED: {
            return {
                ...state,
                infoCategories: {
                    ...state.infoCategories,
                    detail: false,
                },
            };
        }
        case types.DELETE_INFO_CATEGORY_REQUEST: {
            return {
                ...state,
                infoCategories: {
                    ...state.infoCategories,
                    [action.meta.id]: true,
                },
            };
        }
        case types.DELETE_INFO_CATEGORY_REQUEST_COMPLETED: {
            return {
                ...state,
                infoCategories: {
                    ...state.infoCategories,
                    [action.meta.id]: false,
                },
            };
        }
        case types.DELETE_INFO_REQUEST:
        case types.INFO_REQUEST: {
            return {
                ...state,
                info: {
                    ...state.info,
                    [action.meta.id]: true,
                },
            };
        }
        case types.DELETE_INFO_REQUEST_COMPLETED:
        case types.INFO_REQUEST_COMPLETED: {
            return {
                ...state,
                info: {
                    ...state.info,
                    [action.meta.id]: false,
                },
            };
        }
        case types.INFO_DETAIL_REQUEST: {
            return {
                ...state,
                info: {
                    ...state.info,
                    detail: true,
                },
            };
        }
        case types.INFO_DETAIL_REQUEST_COMPLETED: {
            return {
                ...state,
                info: {
                    ...state.info,
                    detail: false,
                },
            };
        }
        default: {
            return state;
        }
    }
};
export default reducer;
